module.exports = __webpack_public_path__ + "static/media/user1.497e51fc.png";